import { Controller } from "@hotwired/stimulus"

// Reloads the page after a configurable delay when this element connects to the DOM.
// Usage: <div data-controller="page-reload" data-page-reload-delay-value="1500"></div>
export default class extends Controller {
  static values = { delay: { type: Number, default: 1500 } }

  connect() {
    this._timeout = setTimeout(() => {
      window.location.reload()
    }, this.delayValue)
  }

  disconnect() {
    if (this._timeout) clearTimeout(this._timeout)
  }
}
